import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99965 7.50005V10.8334M9.99965 14.1667H10.008M8.57465 3.21672L1.51632 15C1.37079 15.2521 1.29379 15.5378 1.29298 15.8288C1.29216 16.1198 1.36756 16.406 1.51167 16.6588C1.65579 16.9117 1.86359 17.1223 2.11441 17.2699C2.36523 17.4175 2.65032 17.4969 2.94132 17.5H17.058C17.349 17.4969 17.6341 17.4175 17.8849 17.2699C18.1357 17.1223 18.3435 16.9117 18.4876 16.6588C18.6317 16.406 18.7071 16.1198 18.7063 15.8288C18.7055 15.5378 18.6285 15.2521 18.483 15L11.4247 3.21672C11.2761 2.9718 11.0669 2.76931 10.8173 2.62879C10.5677 2.48826 10.2861 2.41443 9.99965 2.41443C9.71321 2.41443 9.43159 2.48826 9.18199 2.62879C8.93238 2.76931 8.72321 2.9718 8.57465 3.21672Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAlertTriangle;
